import InfoPage from '@/components/InfoPage';

const ComoFunciona = () => {
  return (
    <InfoPage title="Como Funciona">
      <div className="space-y-6">
        <section>
          <h2 className="text-2xl font-semibold mb-4" style={{ color: '#302681' }}>Para Motoristas</h2>
          <ol className="list-decimal list-inside space-y-3 text-gray-700">
            <li><strong>Abra o aplicativo</strong> - Acesse o ParkingSpot pelo seu navegador</li>
            <li><strong>Visualize o mapa</strong> - Veja todos os estacionamentos disponíveis próximos a você</li>
            <li><strong>Escolha um estacionamento</strong> - Veja vagas disponíveis, preços e horários em tempo real</li>
            <li><strong>Navegue até o local</strong> - Use o mapa interativo para chegar ao estacionamento escolhido</li>
          </ol>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4" style={{ color: '#831D1C' }}>Para Proprietários de Estacionamentos</h2>
          <ol className="list-decimal list-inside space-y-3 text-gray-700">
            <li><strong>Cadastre-se</strong> - Crie uma conta gratuitamente</li>
            <li><strong>Adicione seu estacionamento</strong> - Informe localização, preços e capacidade</li>
            <li><strong>Atualize vagas em tempo real</strong> - Mantenha as informações sempre atualizadas</li>
            <li><strong>Atraia mais clientes</strong> - Seu estacionamento ficará visível para milhares de motoristas</li>
            <li><strong>Conecte sua conta Mercado Pago</strong> e administre o caixa no Mercado Pago</li>
          </ol>
          <p className="mt-4 text-sm text-gray-600 italic">
            * Cobramos somente uma taxa de 0,45% por transação. Hipoteticamente calculando 45 reais de taxa da ParkingSpot para cada 10 mil reais em transação.
          </p>
        </section>

        <section className="bg-gradient-to-r from-green-50 to-blue-50 p-8 rounded-2xl border-2 border-green-400">
          <h2 className="text-3xl font-bold mb-6 text-center" style={{ color: '#009440' }}>
            🛡️ Por Que Escolher o ParkingSpot?
          </h2>
          
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-white p-6 rounded-xl shadow-sm">
              <h3 className="text-xl font-semibold mb-3" style={{ color: '#302681' }}>
                ✅ Segurança para Proprietários
              </h3>
              <ul className="space-y-2 text-gray-700">
                <li>• <strong>Sem dinheiro físico:</strong> Pagamentos 100% digitais via PIX ou cartão</li>
                <li>• <strong>Menos riscos:</strong> Sem preocupação com assaltos ou dinheiro falso</li>
                <li>• <strong>Controle total:</strong> Acompanhe todos os pagamentos pelo dashboard</li>
                <li>• <strong>Comprovantes automáticos:</strong> Registro de todas as transações</li>
              </ul>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-sm">
              <h3 className="text-xl font-semibold mb-3" style={{ color: '#831D1C' }}>
                ✅ Segurança para Clientes
              </h3>
              <ul className="space-y-2 text-gray-700">
                <li>• <strong>Pagamento seguro:</strong> Pague direto do seu celular</li>
                <li>• <strong>Sem terminais quebrados:</strong> Evite maquininhas suspeitas que podem clonar seu cartão</li>
                <li>• <strong>Tecnologia PCI compliant:</strong> Seus dados nunca são armazenados</li>
                <li>• <strong>Comprovante digital:</strong> Recibo de pagamento instantâneo</li>
              </ul>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-sm">
              <h3 className="text-xl font-semibold mb-3" style={{ color: '#009440' }}>
                ⚡ Praticidade
              </h3>
              <ul className="space-y-2 text-gray-700">
                <li>• <strong>Sem filas:</strong> Pague online antes de chegar</li>
                <li>• <strong>Transparência:</strong> Preços claros antes de estacionar</li>
                <li>• <strong>Disponibilidade em tempo real:</strong> Veja vagas disponíveis no mapa</li>
                <li>• <strong>Múltiplas formas de pagamento:</strong> PIX, crédito ou débito</li>
              </ul>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-sm">
              <h3 className="text-xl font-semibold mb-3" style={{ color: '#FFCB00' }}>
                💰 Economia e Confiança
              </h3>
              <ul className="space-y-2 text-gray-700">
                <li>• <strong>Compare preços:</strong> Escolha o melhor custo-benefício</li>
                <li>• <strong>Sem taxas ocultas:</strong> O que você vê é o que você paga</li>
                <li>• <strong>Suporte dedicado:</strong> Estamos aqui para ajudar</li>
                <li>• <strong>Plataforma confiável:</strong> Processamento via Mercado Pago</li>
              </ul>
            </div>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4" style={{ color: '#009440' }}>Legenda do Mapa</h2>
          <div className="space-y-2">
            <div className="flex items-center space-x-3">
              <div className="w-6 h-6 rounded-full" style={{ backgroundColor: '#302681' }}></div>
              <span>Estacionamento Coberto (Indoor)</span>
            </div>
            <div className="flex items-center space-x-3">
              <div className="w-6 h-6 rounded-full" style={{ backgroundColor: '#009440' }}></div>
              <span>Estacionamento Descoberto (Outdoor)</span>
            </div>
            <div className="flex items-center space-x-3">
              <div className="w-6 h-6 rounded-full" style={{ backgroundColor: '#FFCB00' }}></div>
              <span>Estacionamento Misto (Indoor + Outdoor)</span>
            </div>
          </div>
        </section>
      </div>
    </InfoPage>
  );
};

export default ComoFunciona;
